import * as $ from 'jquery';
import lozad from 'lozad';
import { initTracker } from '../../../shared/js/tracker';
import { initShowcaseCore, initBackRedirect } from '../../../shared/js/showcase-core';
import { ready as apiReady } from '../../../shared/js/api-host';

if (process.env.NODE_ENV === 'development') {
  import('../../../shared/mocks/setup');
}

import '../scss/style.scss';
import './components/common';

const observer = lozad();
observer.observe();

$(function () {
  Promise.resolve(apiReady).then(() => {
    initShowcaseCore({
      clickSelector: '.offers__item',
      template,
      showPreloader,
      hidePreloader,
    });

    function applyPersonalization(fields) {
      if (!fields) return;
      const { name, amount, fullamount } = fields;
      const $default = $('[data-default-title]');
      const $personal = $('[data-personalized-title]');

      // Fill known fields if present in DOM
      if (typeof name === 'string' && name) {
        $('[data-field-name]').text(String(name));
      }
      if (typeof amount === 'number' && !Number.isNaN(amount)) {
        const fmt = amount.toLocaleString('ru-RU').replace(/\s/g, '.');
        $('[data-field-amount]').text(fmt);
      }
      if (typeof fullamount === 'number' && !Number.isNaN(fullamount)) {
        const fmtf = fullamount.toLocaleString('ru-RU').replace(/\s/g, '.');
        $('[data-field-fullamount]').text(fmtf);
      }

      // If there is an explicit personalized block placeholder, toggle it when we have enough data
      const canShowPersonal = ($personal.length > 0) && (
        ($('[data-field-name]').length && $('[data-field-amount]').length && typeof amount === 'number')
      );
      if (canShowPersonal) {
        $default.hide();
        $personal.show();
      }
    }

    try {
      const fields = window.__visitData && window.__visitData.fields;
      if (fields) applyPersonalization(fields);
    } catch (_) {}

    window.addEventListener('visit:tracked', (e) => {
      const fields = e && e.detail && e.detail.fields;
      applyPersonalization(fields);
    });
  });
});

initBackRedirect();

function showPreloader(currLink) {
  $(currLink).css('pointer-events', 'none');
  $(currLink).find('.offer-button > .btn-text').addClass('is-hidden');
  $(currLink).find('.offer-button > .btn-loader').addClass('is-visible');
}

function hidePreloader(currLink) {
  $(currLink).css('pointer-events', 'auto');
  $(currLink).find('.offer-button > .btn-text').removeClass('is-hidden');
  $(currLink).find('.offer-button > .btn-loader').removeClass('is-visible');
}

function template(offer) {
  return `
    <div
      class="offers__item"
      data-offer-id="${offer.id}"
      ${offer.offerVisitId ? `data-offer-visit-id="${offer.offerVisitId}"` : ''}
    >
      <div class="offers__item-top">
        <div class="offers__item-logo">
          <img src="${offer.image}" alt="">
        </div>
        <div class="offers__item-tag">
          <span>${offer.tag ? offer.tag : getRandomTag()}</span>
        </div>
      </div>
      <div class="offers__item-details">
        <div class="offers__item-details-item offers__item-details-item_left">
          ${offer.termEnd ? `<span>До ${offer.termEnd} дней</span>` : ''}
          <span>Первый заем <br> бесплатно</span>
        </div>
        <div class="offers__item-details-item offers__item-details-item_right">
          <span class="available">Доступно</span>
          ${offer.amount ? `<span class="price">до ${offer.amount.toLocaleString('ru-RU')} ₽</span>` : ''}
        </div>
      </div>
      <button class="btn btn-full btn-primary offer-button" aria-label="Получить деньги">
        <span class="btn-text">Получить деньги</span>
        <span class="btn-loader"></span>
      </button>
    </div>
  `;
}

function getRandomTag() {
  const tags = ['Без справок', 'Первый займ - бесплатно', 'Без переплат'];
  return tags[Math.floor(Math.random() * tags.length)];
}

initTracker();
